/**
 * The Pro error contract: the translation key of every Pro refusal and the
 * `details` it may carry (`total` on slotsExhausted, `movableAt` on
 * cooldown, `groupId` on alreadyProByYou and groupNotFound).
 */
export const PRO_ERROR_KEYS = {
  notAvailable: 'errors:pro.notAvailable',
  required: 'errors:pro.required',
  slotsExhausted: 'errors:pro.slotsExhausted',
  cooldown: 'errors:pro.cooldown',
  alreadyProByYou: 'errors:pro.alreadyProByYou',
  conflict: 'errors:pro.conflict',
  groupNotFound: 'errors:pro.groupNotFound',
} as const;

export type ProErrorKey = (typeof PRO_ERROR_KEYS)[keyof typeof PRO_ERROR_KEYS];

export type ProErrorDetails = {
  groupId?: string;
  movableAt?: string;
  total?: number;
};

export const GROUP_EXPENSE_LIMIT_ERROR_KEYS = {
  reached: 'errors:expenses.groupLimitReached',
  importOverFreeLimit: 'errors:imports.overFreeLimit',
} as const;

export const EXPENSE_CREATE_ERROR_KEYS = {
  conflict: 'errors:expenses.createConflict',
} as const;

export const FREE_GROUP_EXPENSE_WARNING_AT = 50;
